import type { StepperPosition } from './stepperLayout'
import type { AnimationDirection } from '@meilleurtaux/form-factory'
import type { Slide } from '@meilleurtaux/form-factory-ds'

export type slideStatus = 'showing' | 'hiding' | 'displayed' | 'hidden'
export type slideDirection = 'forward' | 'backward'
export type slideAnimation = React.ComponentProps<typeof Slide>['slideAnimation']

// Sens configuré pour le tunnel :
// 'vertical' / 'horizontal' s'imposent quelle que soit la position du stepper (y compris « left »).
// Sens absent : verticale uniquement avec un stepper en haut ou absent (règle historique).
export const isVerticalAnimation = (
  device: string | undefined,
  stepperPosition?: StepperPosition,
  direction?: AnimationDirection,
) => {
  if (direction) return direction === 'vertical'
  return stepperPosition === 'top' || stepperPosition === 'none'
}

interface ScrollNavigationParams {
  device: string | undefined
  isWidgetMode: boolean
  stepperPosition?: StepperPosition
  animationDirection?: AnimationDirection
}

// Navigation au scroll entre slides : desktop uniquement (sur mobile le scroll reste un scroll de page),
// jamais en widget, et seulement avec une animation verticale.
export const isScrollNavigationEnabled = ({
  device,
  isWidgetMode,
  stepperPosition,
  animationDirection,
}: ScrollNavigationParams) =>
  device === 'Desktop' &&
  !isWidgetMode &&
  isVerticalAnimation(device, stepperPosition, animationDirection)

export const getSlideAnimation = (
  status: slideStatus,
  direction: slideDirection | undefined,
  vertical = false,
): slideAnimation | undefined => {
  switch (status) {
    case 'showing':
      if (direction === 'forward') return vertical ? 'fromBottom' : 'fromRight'
      return vertical ? 'fromTop' : 'fromLeft'
    case 'hiding':
      if (direction === 'forward') return vertical ? 'toTop' : 'toLeft'
      return vertical ? 'toBottom' : 'toRight'
    case 'hidden':
    case 'displayed':
      return undefined
  }
}
